import React, { useEffect, useContext } from 'react';
import {
  Switch,
  Redirect,
  Route,
  useHistory,
  useLocation,
} from 'react-router-dom';
import firebase from 'firebase';

import Home from './screens/Home';
import Login from './screens/Login';
import Register from './screens/Register';
import Game from './screens/Game';
import About from './screens/About';
import Event from './screens/Event';
import Article from './screens/Article';
import Video from './screens/Video';
import Forum from './screens/Forum';
import SinglePost from './screens/SinglePost';

import { auth, analytics } from './services/firebase';
import queryString from 'query-string';
import EditProfile from './screens/EditProfile';
import { fetchAvatar, uploadAvatar } from './services/avatar';
import UserContext from './contexts/UserContext';
import ResetPassword from './screens/ResetPassword';
import Discussion from './screens/Discussion';

const App = () => {
  const history = useHistory();
  const location = useLocation();
  const { dispatch } = useContext(UserContext);

  const updateAvatar = async (
    imgUrl: string | null,
    provider: string | undefined,
    uid: string
  ): Promise<string> => {
    const url = await fetchAvatar(uid);
    if (auth.currentUser?.photoURL !== url) {
      await auth.currentUser?.updateProfile({ photoURL: url });
    }
    if (url !== undefined) {
      return url;
    } else {
      if (provider !== 'password' && imgUrl) {
        return await uploadAvatar(imgUrl, uid);
      }
    }

    return '';
  };

  useEffect(() => {
    const updateUser = async (result: firebase.User) => {
      const provider = result.providerData[0]?.providerId;
      const photoUrl = await updateAvatar(
        result?.photoURL,
        provider,
        result.uid
      );
      const user = {
        displayName: result?.displayName || '',
        photoUrl,
        provider: provider || '',
        email: result.email || '',
        uid: result.uid || '',
      };
      dispatch({ type: 'SET_USER', payload: { user } });
    };
    auth.onAuthStateChanged((result: firebase.User | null) => {
      if (result) {
        updateUser(result);
        const { redirect_url } = queryString.parse(location.search);
        if (['/login', '/register'].includes(history.location.pathname)) {
          history.push(redirect_url ? redirect_url.toString() : '/');
        }
        analytics.setUserId(result.uid);
      } else {
        dispatch({ type: 'LOG_OUT' });
      }
    });
  }, [location.search, history, dispatch]);

  useEffect(() => {
    analytics.setCurrentScreen(location.pathname);
    analytics.logEvent('page_enter', {
      page_location: window.location.href,
      page_path: location.pathname,
    });
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Switch>
      <Route path="/" component={Home} exact />
      <Route path="/game" component={Game} />
      <Route path="/about" component={About} />
      <Route path="/event" component={Event} />
      <Route path="/article" component={Article} />
      <Route path="/video" component={Video} />
      <Route path="/forum" component={Forum} />
      <Route path="/login" component={Login} exact />
      <Route path="/register" component={Register} exact />
      <Route path="/post/:type/:id" component={SinglePost} />
      <Route path="/profile" component={EditProfile} />
      <Route path="/reset-password" component={ResetPassword} />
      <Route path="/discussion/:id" component={Discussion} />
      <Route
        path="/csa2022"
        render={() => {
          window.location.replace('https://www.csa2022.com/');
          return <></>;
        }}
      />
    </Switch>
  );
};

export default App;
